// BM-H398 - s3_executors. `substitutes` drives C-06, `professional_executor`
// drives C-07. Each executor is a register reference.

import { FIRM_NAME } from "../../../config/constants";
import { QuestionRow, SectionIntro, Select, YesNo, sectionProps } from "./fields";
import { PeopleList } from "./PersonPicker";
import S3Trustees from "./S3Trustees"; // BM-H3883

// The engine reads only `professional_executor !== "none"` (C-07). The firm's
// name comes from the white-label config, never a literal here.
export const PROFESSIONAL_OPTIONS = [
  { value: "none", label: "No, family and friends only" },
  { value: "firm_co_executor", label: `Yes, ${FIRM_NAME} alongside the people I name` },
  { value: "firm_sole", label: `Yes, ${FIRM_NAME} as my only executor` },
];

export default function S3Executors({ section, setSection, payload, update, person }) {
  const { s, set, nk, setNk } = sectionProps(section, setSection);
  const primary = s.primary || [];
  const withRole = (items) => items.map((x) => ({ role: "executor_and_trustee", agreed_in_principle: null, ...x }));

  return (
    <div data-testid="section-s3_executors">
      <SectionIntro title="Your executors and trustees">
        Executors administer your estate after your death. Trustees hold money or assets for someone who cannot take them outright. Most people appoint the same people as both.
      </SectionIntro>

      <PeopleList
        payload={payload}
        update={update}
        items={primary}
        onChange={(items) => set({ primary: withRole(items) })}
        qid="s3_executors.primary"
        label="Executor"
        testid="s3-primary"
        exclude={[person?.id]}
        renderExtra={(item, i) => (
          <QuestionRow qid="s3_executors.primary.agreed_in_principle" label="Have they agreed in principle to act?" testid={`s3-primary-${i}-q-agreed`}>
            <YesNo testid={`s3-primary-${i}-agreed`} value={item.agreed_in_principle ?? null} onChange={(v) => set({ primary: primary.map((x, j) => (j === i ? { ...x, agreed_in_principle: v } : x)) })} />
          </QuestionRow>
        )}
      />

      <div style={{ marginTop: 18 }}>
        <PeopleList
          payload={payload}
          update={update}
          items={s.substitutes || []}
          onChange={(items) => set({ substitutes: withRole(items) })}
          qid="s3_executors.substitutes"
          label="Substitute executor"
          testid="s3-substitutes"
          exclude={[person?.id, ...primary.map((x) => x.person_id).filter(Boolean)]}
        />
      </div>

      <div style={{ marginTop: 18 }}>
        <QuestionRow qid="s3_executors.professional_executor" label="Would you like a professional executor?" notKnown={nk("professional_executor")} onNotKnown={(on) => setNk("professional_executor", on)}>
          <Select testid="s3-professional" value={s.professional_executor} disabled={nk("professional_executor")} options={PROFESSIONAL_OPTIONS} onChange={(v) => set({ professional_executor: v })} />
        </QuestionRow>
        <QuestionRow qid="s3_executors.same_as_trustees" label="Should the same people act as your trustees?">
          <YesNo testid="s3-same-as-trustees" value={s.same_as_trustees} onChange={(v) => set({ same_as_trustees: v })} />
        </QuestionRow>
        {s.same_as_trustees === false && (
          <S3Trustees section={s} set={set} payload={payload} update={update} testatorId={person?.id} />
        )}
      </div>
    </div>
  );
}
